import React, {Component} from 'react';
import TextField from './TextField';

export default class SuccessCriteria extends Component {
  render() {
    return (
      <div className="col-md persona-section_spacing">
        <TextField formKey="criteria_for_success" {...this.props}/>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./client/pages/persona/SuccessCriteria.jsx